import React, { useId } from 'react'
import PropTypes from 'prop-types'

const EditIcon = React.forwardRef(function EditIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M15.71 6.29C15.32 5.9 14.69 5.9 14.3 6.29L2.3 18.29C2.19 18.4 2.11 18.53 2.06 18.68L1.06 21.68C.940001 22.04 1.03 22.44 1.3 22.7 1.48 22.89 1.74 23 2 23 2.11 23 2.21 22.98 2.32 22.95L5.32 21.95C5.47 21.9 5.6 21.82 5.71 21.71L17.71 9.71C18.1 9.32 18.1 8.69 17.71 8.3L15.71 6.29ZM22.27 1.72999C21.71 1.16999 21.09.929991 20.42 1.01999 19.75 1.09999 19.07 1.50999 18.27 2.30999L17.27 3.35999C16.9 3.74999 16.9 4.36999 17.29 4.75999L19.23 6.70999C19.43 6.89999 19.69 6.99999 19.94 6.99999 20.19 6.99999 20.43 6.90999 20.63 6.72999L21.7 5.70999C23.21 4.19999 23.4 2.85999 22.27 1.72999Z"></path>
    </svg>
  )
})

EditIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

EditIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default EditIcon
